import { SimplePageContentWrapper, SimplePageLayout, SimplePageHeader } from '@flexinet/ui-components';
import { ReportsRecordsTable } from '../../customer-subscriptions/tables/ReportsRecordsTable';
import { ReportPageNavigation } from '../navigation/ReportPageNavigation';

export const SubscriptionsReportPage = () => {
  return (
    <SimplePageLayout
      pageHeader={<SimplePageHeader title="Subscriptions Report" />}
      pageNavigation={<ReportPageNavigation reportName="Subscriptions Report" />}
    >
      <SimplePageContentWrapper>
        <ReportsRecordsTable />
      </SimplePageContentWrapper>
    </SimplePageLayout>
  );
};